import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTabsModule } from '@angular/material/tabs';
import { OrganizationDetailComponent } from './tabs/organization-detail.component.js';
import { OrganizationMetricsComponent } from './tabs/organization-metrics.component.js';
import { OrganizationUsersComponent } from './tabs/organization-users.component.js';
import { OrganizationPatientMetricsComponent } from './tabs/organization-patient-metrics.component.js';
import { OrganizationDCIMetricsComponent } from './tabs/organization-dci-metrics.component.js';

/** The organizations list page */
@Component({
	selector: 'app-organization',
	imports: [
		MatIconModule,
		MatButtonModule,
		MatTabsModule,
		OrganizationDetailComponent,
		OrganizationMetricsComponent,
		OrganizationUsersComponent,
		OrganizationPatientMetricsComponent,
		OrganizationDCIMetricsComponent

	],
	templateUrl: './organization.component.html',
	styleUrl: './organization.component.scss'
})
export class OrganizationComponent implements OnInit, OnDestroy {

	constructor() {
	}

	ngOnInit() {
	}

	private refresh() {
	}

	ngOnDestroy() {
	}
}
